import { render } from "./RequestNewPosts.vue?vue&type=template&id=22638667&ts=true"
import script from "./RequestNewPosts.vue?vue&type=script&lang=ts"
export * from "./RequestNewPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__